// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app'
import 'firebase/firestore'

import 'firebase/performance'

// firebase init goes here
const config = {
  apiKey:            'AIzaSyDNxeYT0cIpH1OY70jdh69u0a43NddcHY0',
  authDomain:        'crazytrip-01.firebaseapp.com',
  databaseURL:       'https://crazytrip-01.firebaseio.com',
  projectId:         'crazytrip-01',
  storageBucket:     'crazytrip-01.appspot.com',
  messagingSenderId: '376814094007',
  appId:             '1:376814094007:web:0d56da74f0aa8235'

}
firebase.initializeApp(config)

// Performance
const perf = firebase.performance()

// firebase utils
const db        = firebase.firestore()
const firestore = firebase.firestore

const googleAuthProvider = firebase.auth.GoogleAuthProvider
const auth               = firebase.auth()
const storage            = firebase.storage()
const currentUser        = auth.currentUser

// firebase collections
const usersCollection    = db.collection('users')
const tripsCollection    = db.collection('trips')
const mediasCollection   = db.collection('medias')
const commentsCollection = db.collection('comments')
const likesCollection    = db.collection('likes')
const activityCollection = db.collection('activities')

const fb = firebase
export {
  fb,
  db,
  perf,
  firestore,
  auth,
  storage,
  googleAuthProvider,
  currentUser,
  usersCollection,
  mediasCollection,
  tripsCollection,
  commentsCollection,
  likesCollection,
  activityCollection,
}
